(function componentForm($, Adzuki) {
	"use strict";

	var form = {
		name: 'CreateTripSummary',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var editorRef;

		$(".radio-include-cruise").on('change', function tog() {
			$('#trip-summary-dates').toggleClass('hidden');
			$('#trip-summary-sailing').toggleClass('hidden');
			$('.cruise-notes').toggleClass('hidden');
		});

		if ($('.radio-include-cruise').length > 0) {
			$('.cruise-notes').removeClass('hidden');
		}

		// listen for ready event to access editor reference
		$("#createtripsummary-description").on('editor.ready', function editorReady(event, editor) {
			// editor is a reference to the tinymce editor. use it as you see fit.
			editorRef = editor;
		});

		// cruise line drop-down changed, clear the brief description in case it's populated with another ship's description
		$("#createtripsummary-cruise_line").on('change', function cruiseLineChange(event) {
			setBriefDescription('', event);
		});

		// ship drop-down changed, set the brief description
		$("#createtripsummary-ships").on('change', function shipChange(event) {
			var ship_id = $(this).val();

			Adzuki.Ajax.get('/Ships/ajaxGetShipDetails/' + ship_id).then(function success(data) {
				setBriefDescription(data.ships.description, event);
			});
		});

		function setBriefDescription(new_description, event)
		{
			var current_content, message;
			if (editorRef !== undefined) {

				current_content = editorRef.getContent();

				// confirm that they want to change the brief description
				if (current_content.length > 0) {
					if (new_description.length > 0) {
						message = 'Do you wish to reset the "Brief Description" field with this ship\'s description?';
					} else {
						message = 'Do you wish to clear the "Brief Description" field since the ship will be changing?';
					}

					Adzuki.CustomConfirm({
						body   : message,
						confirm: function confirm() {
							editorRef.setContent(new_description);
							$('#createtripsummary-description').val(new_description);
						}
					});
				// it's empty anyway, so let's set it to the ship's description
				} else {
					editorRef.setContent(new_description);
					$('#createtripsummary-description').val(new_description);
				}
			}
		}
	};

}(jQuery, window.Adzuki || {}));
